<template>
  <b-row>
    <b-col sm="12">
      <b-card :title = "metadata.label">
        <b-form-file ref="fileinput" v-model="files" :multiple="metadata.multiple" plain></b-form-file>
        <div class="card-columns">
          <template v-for="(item, index) in vattachments">
            <div :class="'card ' + (vattachments[index].selected?'text-white bg-primary':'')"
              :key="'card_'+index" @click="clickSelect(index)">
              <img class="card-img-top" :src="loadedFiles[index]">
              <div class="card-body">
                <h5 class="card-title">{{vattachments[index].name}}</h5>
                <b-button type="button" variant="danger" @click="deleteAttachment(index)" >Eliminar</b-button>
              </div>
            </div>
          </template>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import FormComponentBase from './FormComponentBase'
import AttachmentsLoader from '../auxx/AttachmentsLoader'
import { mapState, mapActions } from 'vuex'
import Vue from 'vue'
import store from '../../store'

export default {
  name: 'FormComponentFile',
  extends: FormComponentBase,
  /* components: {
    FormComponent: () => import('./FormComponent')
  }, */
  data () {
    return {
      files: [],
      // loadedFiles: {},
      pendingFiles: [],
      pendingFile: null,
      vattachments: {},
      attachmentsLoader: null
    }
  },
  computed: {
    ...mapState({
      'currmodel': 'currmodel',
      'metadatax': 'metadata'
    }),
    loadedFiles () {
      if (this.attachmentsLoader) {
        return this.attachmentsLoader.loadedFiles
      }
      return {}
    }
  },
  mounted () {
    if (this.value) {
      this.vattachments = this.value
    }
    let AttachmentsLoaderClass = Vue.extend(AttachmentsLoader)
    this.attachmentsLoader = new AttachmentsLoaderClass({
      router: this.$router,
      store,
      propsData: {
        idx: this.currmodel._id,
        vattachments: this.vattachments
      }
    })
    this.attachmentsLoader.$mount()
  },
  watch: {
    /* 'currmodel._attachments': function (to) {
      for (var i in this.pendingFiles) {
        this.$delete(this.pendingFiles, i)
        this.addLoadedFile(i)
      }
    }, */
    pendingFile: function (val) {
      var obj = this
      if (val) {
        obj.get_db().then(function (db) {
          db.getAttachment(obj.currmodel._id, obj.pendingFile).then(function (att) {
            // console.log(att)
            obj.$set(obj.loadedFiles, obj.pendingFile, window.URL.createObjectURL(att))
            obj.pendingFile = null
          }).catch(function (err) {
            console.log(err)
          })
        }).catch(function (err) {
          console.log(err)
        })
      } else {
        if (obj.pendingFiles.length > 0) {
          obj.pendingFile = obj.pendingFiles.pop()
        }
      }
    },
    value: function (val) {
      this.$set(this, 'vattachments', val)
      this.attachmentsLoader.idx = this.currmodel._id
      this.attachmentsLoader.vattachments = this.vattachments
      this.$emit('valuechange', val)
    },
    vattachments: function (to, from) {
      /* if (to !== from) {
        for (var i in to) {
          if (!(i in from)) {
            this.addLoadedFile(i)
          }
        }
      } */
    },
    files (to, from) {
      let obj = this
      var arr = []
      if (Array.isArray(to)) {
        arr = to
      } else {
        if (to) {
          arr.push(to)
        }
      }
      if (arr.length) {
        try {
          var timestamp = new Date().getTime().toString()
          for (var i = 0; i < arr.length; i++) {
            var file = arr[i]
            // var name = file.name
            obj.emitAddAttachment(timestamp, {
              content_type: file.type,
              data: file
            })
            obj.$set(obj.vattachments, timestamp, {
              name: file.name
            })
            // obj.addLoadedFile(timestamp)
            obj.loadedFiles[timestamp] = window.URL.createObjectURL(file)
            timestamp++
          }
          var userAgent = window.navigator.userAgent
          if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
            console.log('apple :(')
          } else {
            obj.$refs.fileinput.reset()
          }
          obj.$emit('input', obj.vattachments)
        } catch (err) {
          console.log(err)
          obj.setMessage('files: ' + JSON.stringify(err))
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'get_db'
    ]),
    addLoadedFile (id) {
      /* if (this.currmodel._attachments && this.currmodel._attachments[id]) {
        this.loadedFiles[id] = window.URL.createObjectURL(this.currmodel._attachments[id].data)
      } else {
        this.pendingFiles[id] = id
      } */
      this.pendingFiles.push(id)
      if (this.pendingFile === null) {
        this.pendingFile = this.pendingFiles.pop()
      }
    },
    deleteAttachment (id) {
      this.$delete(this.vattachments, id)
      this.$emit('input', this.vattachments)
      this.emitDeleteAttachment(id)
    },
    emitAddAttachment (id, payload) {
      this.$emit('updatex', {
        action: 'set',
        target: '_attachments',
        id: id,
        object: payload
      })
    },
    emitDeleteAttachment (id) {
      this.$emit('updatex', {
        action: 'delete',
        target: '_attachments',
        id: id
      })
    },
    clickSelect (key) {
      for (var i in this.vattachments) {
        this.$set(this.vattachments[i], 'selected', false)
      }
      this.$set(this.vattachments[key], 'selected', true)
      this.$emit('input', this.vattachments)
      // console.log(key)
    }
  }
}
</script>
